import { render, staticRenderFns } from "./ApprovalCc.vue?vue&type=template&id=470535d2&scoped=true&"
import script from "./ApprovalCc.vue?vue&type=script&lang=js&"
export * from "./ApprovalCc.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalCc.vue?vue&type=style&index=0&id=470535d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470535d2",
  null
  
)

export default component.exports